import { getCityName, getCityNameByIATA } from 'app/api/common';
import Helper from 'app/modules/Helper';
import { capitalize } from 'lodash';
import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkCookieSearchData, init } from '../../actions/baseActions';
import Cars from '../../app/components/Cars/Cars';
import { Vertical, getSanityPage } from '../../app/modules/Sanity';

interface CarsPageProps {
	page?: {
		title?: string;
		metaDescription?: string;
		h2?: string;
		cityName?: string;
	};
	hotelName?: string;
	place?: string | string[];
}

const CarsPage: NextPage<CarsPageProps> = (props) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	useEffect(() => {
		init('cars')(dispatch);
		checkCookieSearchData()(dispatch);
	}, []);

	const descriptionWithCityName = props.page?.cityName ? t('slug.cars.h2', { cityName: props.page?.cityName }) : undefined;

	const page = {
		...props.page,
		metaDescription: props.page?.metaDescription || descriptionWithCityName,
		h2: props.page?.h2 || descriptionWithCityName
	}

	return (
		<div>
			<NextSeo
				title={page?.title || t('metadata.cars.title')}
				description={page?.metaDescription || t('metadata.cars.description')}
				canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/cars`}
				openGraph={{
					url: `${process.env.NEXT_PUBLIC_SITE_URL}/cars`,
					title: page?.title || t('metadata.cars.title'),
					description: page?.metaDescription || t('metadata.cars.description'),
					site_name: process.env.NEXT_PUBLIC_SITE_NAME,
				}}
			/>
			<Cars page={page} />
		</div>
	);
};
CarsPage.getInitialProps = async (ctx) => {
	// destcode can be either IATA code or city name (with country code, c:[code])
	const destcode = (ctx.query.destcode || ctx.query.destCode) as string;
	const slug = capitalize((ctx.query.slug as string).replaceAll('-', ' ') || '');

	let slugText = slug;
	let cityNameByIATA;

	try {
		slugText = Helper.startCase(slug);
	} catch (e) {
		console.log(e);
	}

	if (destcode) {
		try {
			if (destcode.includes(':')) {
				cityNameByIATA = await getCityName(destcode);
			} else {
				cityNameByIATA = await getCityNameByIATA(destcode);
			}

			const cityName = cityNameByIATA;
			const h1 = `${slugText}`;
			const page = { title: h1, h1, cityName };

			return { page };
		} catch (e) {
			console.error(e);
		}
	}

	const vertical = Vertical.CARS;
	const page = await getSanityPage(ctx, vertical);

	if (!page) {
		if (ctx.res) {
			ctx.res.statusCode = 404;
		}
		return {
			notFound: true,
		};
	} else {
		return { page };
	}
};
export default CarsPage;
